import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AdminDashboard.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload, faEnvelopeOpenText, faUsersCog } from '@fortawesome/free-solid-svg-icons'; // Example icons

const AdminDashboard = () => {
  const dashboardItems = [
    {
      title: 'Upload Blog',
      description: 'Create, edit, and publish new blog posts.',
      path: '/upload-blog',
      icon: faFileUpload,
      color: '#28a745' // Example color for this card
    },
    {
      title: 'Contact Us Data',
      description: 'View and manage submissions from the contact form.',
      path: '/contactus-data',
      icon: faEnvelopeOpenText,
      color: '#17a2b8'
    },
    {
      title: 'Hiring Applications',
      description: 'Review and manage job applications.',
      path: '/hiring-data',
      icon: faUsersCog,
      color: '#ffc107'
    },
    // Add more items as needed
    // {
    //   title: 'User Management',
    //   description: 'Manage user accounts and permissions.',
    //   path: '/user-management',
    //   icon: faUserShield,
    //   color: '#6f42c1'
    // },
  ];

  return (
    <div className={styles.dashboardContainer}>
      <header className={styles.dashboardHeader}>
        <h1>Admin Dashboard</h1>
        <p>Welcome! Manage your application content and data from here.</p>
      </header>
      <div className={styles.dashboardGrid}>
        {dashboardItems.map((item, index) => (
          <Link to={item.path} key={index} className={styles.dashboardCardLink}>
            <div className={styles.dashboardCard} style={{ '--card-accent-color': item.color }}>
              <div className={styles.cardIcon}>
                <FontAwesomeIcon icon={item.icon} size="3x" />
              </div>
              <div className={styles.cardContent}>
                <h2 className={styles.cardTitle}>{item.title}</h2>
                <p className={styles.cardDescription}>{item.description}</p>
              </div>
              <div className={styles.cardArrow}>
                →
              </div>
            </div>
          </Link>
        ))}
      </div>
      <footer className={styles.dashboardFooter}>
        <p>© {new Date().getFullYear()} Your Company Name. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default AdminDashboard;